import { CATEGORIES, CATEGORY_ALIAS } from '@app/src/config/categories';

const pathsProperty = CATEGORIES[CATEGORY_ALIAS.INMUEBLE].paths;
const pathsEmployment = CATEGORIES[CATEGORY_ALIAS.EMPLEO].paths;
const pathsOpportunity = CATEGORIES[CATEGORY_ALIAS.OPORTUNIDAD].paths;
const pathsVehicle = CATEGORIES[CATEGORY_ALIAS.VEHICULO].paths;
const pathsEducation = CATEGORIES[CATEGORY_ALIAS.EDUCACION].paths;

export const navigationMainList = [
  {
    text: 'inmuebles',
    url: pathsProperty.purchasePrint.stepOne,
    pasarella: 'purchase-print'
  },
  {
    text: 'vehículos',
    url: pathsVehicle.purchasePrint.stepOne,
    pasarella: 'purchase-print'
  },
  {
    text: 'empleos',
    url: pathsEmployment.purchasePrint.stepOne,
    pasarella: 'purchase-print'
  },
  {
    text: 'educación',
    url: pathsEducation.purchasePrint.stepOne,
    pasarella: 'purchase-print'
  },
  {
    text: 'oportunidades',
    url: pathsOpportunity.purchasePrint.stepOne,
    pasarella: 'purchase-print'
  },
  {
    text: 'agencias',
    url: '/agencias'
  },
  {
    text: 'paquetes',
    url: '/compra-tu-paquete-de-avisos-impreso',
    pasarella: 'purchase-package',
    new: true
  },
]